module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"indicative-nav":"Indicative Nav","historical-nav":"Historical Nav"},"ar":{"indicative-nav":"صافي قيمة الأصول الاسترشادي","historical-nav":"صافي قيمة الأصول التاريخية"}}')
  delete Component.options._Ctor
}
